const { Tracker } = require('@reverbdotcom/discovery-ui');

function init() {
  const trackedClicks = {};
  const badgeSelector = '[data-badge-view]';

  $(badgeSelector).on('click', (event) => {
    const badgeViewName = $(event.target).closest(badgeSelector).data('badge-view');

    if (!trackedClicks[badgeViewName]) {
      trackedClicks[badgeViewName] = true;

      Tracker.trackInteraction({
        name: 'Dashboard',
        type: badgeViewName,
      });
    }
  });
}

$(init);

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/index.js